import { FacebookIcon, FaxIcon, LinkedInIcon, Telephone, TopArrow, UnityLogoWhite } from "../../assets/svgs";
import { useNavigate, Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-gray-800 text-white text-center  flex flex-col relative">
      <div className="top flex lg:gap-2 gap-4 flex-col  md:flex-wrap lg:flex-row justify-between  md:items-start  px-12 md:px-24 py-10">
        <div
          className="logoBox flex flex-row gap-2 items-center cursor-pointer transition-all duration-300"
          onClick={() => navigate("/")}
        >
          <UnityLogoWhite />
          {/* <h1
            className={`text-2xl font-black text-white font-montserrat whitespace-nowrap transition-all hidden md:block duration-300`}
          >
            Unity Fabric Industries Ltd.
          </h1> */}
        </div>
        <div className="importantLinks flex flex-col text-left">
          <h1 className="title text-sm text-white mb-2 font-regular">
            Important Links
          </h1>
          <Link
            to="/about"
            className="text-slate-300 font-thin text-sm mb-1  hover:text-white duration-300"
          >
            Home
          </Link>
          <Link
            to="/about"
            className="text-slate-300 font-thin text-sm mb-1  hover:text-white duration-300"
          >
            About
          </Link>
          <Link
            to="/awards"
            className="text-slate-300 font-thin text-sm mb-1  hover:text-white duration-300"
          >
            Awards
          </Link>
          <Link
            to="/about"
            className="text-slate-300 font-thin text-sm  mb-1 hover:text-white duration-300"
          >
            Sustainability & CSR
          </Link>
        </div>
        <div className="contactInfo flex flex-col text-left">
          <h1 className="title text-sm text-white mb-2 font-regular">
            Head Office
          </h1>
          <h1 className="text-slate-300  font-thin text-sm mb-2  hover:text-white duration-300">
            House #49,(GR, FLOOR). Lane # 11<br></br>New D.O.H.S Mohakhali, Dhaka 1206,<br></br>Bangladesh.
          </h1>
          <h1 className="title text-sm text-white mb-2 font-regular">
            Factory
          </h1>
          <h1 className="text-slate-300 font-thin text-sm mb-2  hover:text-white duration-300">
            Unity Fabric Industries Limited<br></br>Master Bari, Mirzapur Road, Gazipur,<br></br>Bangladesh
          </h1>
        </div>
        <div className="contactNo flex flex-col text-left">
          <div className="telephone text-sm">
          <h1 className="title  text-white mb-2 font-regular">
            Contact
          </h1>
            <h1 className="flex flex-row text-slate-300 mb-2 gap-1">
              <Telephone/>{" "} +88 029891164
              
            </h1>
            <h1 className="flex flex-row text-slate-300 mb-3 gap-1">
              <FaxIcon/>{" "} +88 029891164
              
            </h1>
            <h1 className="title  text-white mb-3 font-regular">
            Social Media
          </h1>
            <h1 className="flex flex-row text-slate-300 mb-2 gap-4 items-center">
              <Link to="/"> <FacebookIcon/></Link> <Link to="/"> <LinkedInIcon/></Link>
              
            </h1>
            
            
          </div>
        </div>
        <div className="mapAddress flex flex-col text-left text-sm">
        <h1 className="title  text-white mb-2 font-regular">
            Factory Map
          </h1>
          <div className="map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14570.827033434043!2d90.37075!3d24.076629!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755df12a199e89b%3A0x48102102c0bea151!2sUnity%20Fabric%20Industries%20Limited%20(Unit-2)%20(ID-23652)!5e0!3m2!1sen!2sbd!4v1742316174852!5m2!1sen!2sbd" width="240" height="180"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </div>
      <p className="py-2 border-t text-xs border-slate-600">
        &copy; 2025 Unity Fabric Industries Ltd. All rights reserved.
      </p>

      {/* <div className="topNavigation fixed  z-100 h-full">
        <TopArrow />
      </div> */}
    </footer>
  );
};

export default Footer;
